var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDiamond = function SvgDiamond(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 42 42"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6,
    clipPath: "url(#diamond_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.335 10.692a4 4 0 0 1 3.43-1.942h16.47a4 4 0 0 1 3.43 1.942l2.568 4.28a4 4 0 0 1-.449 4.725L21.875 34.125a1.225 1.225 0 0 1-1.75 0L7.215 19.697a4 4 0 0 1-.448-4.725z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 21 14 17.15l1.05-1.75"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "diamond_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h42v42H0z"
  })))));
};
export default SvgDiamond;